var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import themeStyles from './DonutChart.styles';
import DonutChartUi from './DonutChartUi';
import { DonutChartMaxSections } from '../utils';
var DonutChart = function (_a) {
    var fields = _a.fields;
    if (!fields) {
        return null;
    }
    var chartTitle = fields.chartTitle, rest = __rest(fields, ["chartTitle"]);
    var donutDataArray = [];
    // build the data array for donut chart in the format that is expected by recharts utility
    for (var i = 0; i <= DonutChartMaxSections; i++) {
        if (rest["chartLabel".concat(i + 1)] && rest["chartValue".concat(i + 1)]) {
            var name = rest["chartLabel".concat(i + 1)];
            var value = rest["chartValue".concat(i + 1)];
            var color = rest["chartColor".concat(i + 1)];
            var nameValue = (name === null || name === void 0 ? void 0 : name.value) || '';
            var valueStr = (value === null || value === void 0 ? void 0 : value.value) || '';
            var colorValue = (color === null || color === void 0 ? void 0 : color.value) || '';
            if (nameValue !== '' && valueStr !== '' && colorValue !== '') {
                var parsedValue = parseFloat(valueStr.toString());
                if (!Number.isNaN(parsedValue) && parsedValue >= 0) {
                    donutDataArray.push({
                        name: name === null || name === void 0 ? void 0 : name.value,
                        value: parseFloat(value === null || value === void 0 ? void 0 : value.value),
                        color: color === null || color === void 0 ? void 0 : color.value,
                    });
                }
            }
        }
    }
    var GraphicContainer = themeStyles.apply('div', 'GraphicContainer');
    return (React.createElement(GraphicContainer, { "data-testid": "graphic-container" },
        React.createElement(DonutChartUi, { chartData: donutDataArray, chartTitle: chartTitle === null || chartTitle === void 0 ? void 0 : chartTitle.value })));
};
export default DonutChart;
